import dayjs from 'dayjs';

import { IVendorQuote } from 'quotes/types';

export const getRowClass = (quote?: IVendorQuote) => {
  if (!quote) {
    return '';
  }

  if (dayjs(quote.validUntil).isBefore(new Date())) {
    return 'disabledRow';
  }

  return '';
};
